
var EINFormatter = Class.create({
    initialize: function() {},
    format: function(value) {
        var formatNumber = value
        .match(/\d*/g).join('')
        .match(/(\d{0,2})(\d{0,7})/).slice(1).join('-')
        .replace(/-*$/g, '');

        return formatNumber;
    }
});

export let einFormatter = new EINFormatter();


// WEBPACK FOOTER //
// app/helpers/General/EINFormatter.js